import { isPartOfMegaMenu } from './descriptor.is-part-of-megamenu.js';
import { openMegaMenuAtBreadcrumb } from './megamenu.open-at-breadcrumb.js';
import { findPageDescriptorByPath } from './util.find-page-descriptor-by-path.js';

function autoOpenMegaMenuOnMount(configStore, sitemapStore, path, isMobile) {
  const pageDescriptor = findPageDescriptorByPath(
    sitemapStore.getState(),
    path
  );
  if (pageDescriptor && isPartOfMegaMenu(sitemapStore.getState(), pageDescriptor)) {
    openMegaMenuAtBreadcrumb(configStore, sitemapStore, pageDescriptor, {
      isMobile
    });
  }
}

export { autoOpenMegaMenuOnMount };
//# sourceMappingURL=megamenu.auto-open-on-mount.js.map
